import Typography from '@/components/Typography';

import { headerPromptStyles, headerSubtitleStyles, headerTitleStyles } from './styles';

const OnboardingHeader = () => {
  return (
    <>
      <Typography
        size={32}
        sx={headerTitleStyles}
      >
        Start your free 14-day GX Go trial
      </Typography>
      <Typography
        size={20}
        sx={headerSubtitleStyles}
      >
        No credit card required
      </Typography>
      <Typography
        size={24}
        sx={headerPromptStyles}
      >
        Let's start with your work email...
      </Typography>
    </>
  );
};

export default OnboardingHeader;
